const MTIProjectId = '935eae0b-768d-47ca-8814-0156e03b4531';

const url = "//fast.fonts.net/t/1.css?apiType=css&projectid=" + MTIProjectId;
const Http = new XMLHttpRequest();

Http.open("GET", url);
Http.send();